import { Pipe, PipeTransform } from '@angular/core';
import { CodeService } from '../../shared/init/code.service';

@Pipe({
  name: 'countryCode',
})
export class CountryCodePipe implements PipeTransform {
  constructor(private codeService: CodeService) {}

  transform(cca2s: string | string[], seperator?: string): any {
    seperator = seperator || ', ';
    if (Array.isArray(cca2s)) {
      return cca2s
        .map((cca2) => {
          const country = this.codeService.getCountryCode(cca2);
          return country ? country.name.common : '';
        })
        .sort((item1: any, item2: any) => {
          return item1.toString().localeCompare(item2);
        })
        .join(seperator);
    } else {
      const country = this.codeService.getCountryCode(cca2s);
      return country ? country.name.common : '';
    }
  }
}
